import { render } from "./iconsCurrency.vue?vue&type=template&id=f3471a1a&ts=true"
import script from "./iconsCurrency.vue?vue&type=script&lang=ts"
export * from "./iconsCurrency.vue?vue&type=script&lang=ts"

import "./iconsCurrency.vue?vue&type=style&index=0&id=f3471a1a&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__